import * as XLSX from 'xlsx';

interface IBatchCategory {
  content: IBatchCategoryContent[];
  pageable: any;
  total_elements: number;
  total_pages: number;
  last: boolean;
  size: number;
  number: number;
  sort: any;
  number_of_elements: number;
  first: boolean;
  empty: boolean;
}

interface IBatchCategoryContent {
  batch_id: number;
  initials: string;
  batch_capacity_rate: number;
  status: string;
  farm_name: string;
  farm_initials: string;
  area_name: string;
  area_initials: string;
  area_acreage: number;
  micro_area: string;
  categories: Category[];
}

interface Category {
  id: number;
  name: string;
  month_reference: number;
  quantity: number;
  age_description: string;
  unit: string;
}

export const exportBatchesDataToExcel = (batchCategory: IBatchCategory) => {
  if (!batchCategory || !batchCategory.content || batchCategory.content.length === 0) {
    throw new Error('Dados insuficientes para exportação');
  }

  const maleCategoryIds = [6, 7, 8, 9, 10, 11];
  const femaleCategoryIds = [1, 2, 3, 4, 5];

  const rows: any[][] = [];

  const headerRow: any[] = [
    'Lotes',
    ...maleCategoryIds.map(() => ''),
    ...femaleCategoryIds.map(() => ''),
    'Saldo'
  ];
  rows.push(headerRow);

  const subHeaderRow: any[] = [
    '',
    '0 a 8 meses',
    '9 a 12 meses',
    '13 a 24 meses',
    '25 a 36 meses',
    '> 37 meses',
    'Touros',
    '0 a 8 meses',
    '9 a 12 meses',
    '13 a 24 meses',
    '25 a 36 meses',
    '> 37 meses',
    ''
  ];
  rows.push(subHeaderRow);

  batchCategory.content.forEach((batch) => {
    const row: any[] = [
      `${batch.farm_initials}-${batch.area_initials}-${batch.initials}`,
      ...maleCategoryIds.map((id) => {
        const category = batch.categories.find((cat) => cat.id === id);
        return category?.quantity || 0;
      }),
      ...femaleCategoryIds.map((id) => {
        const category = batch.categories.find((cat) => cat.id === id);
        return category?.quantity || 0;
      }),
      batch.categories.reduce((sum, category) => sum + category.quantity, 0)
    ];
    rows.push(row);
  });

  const totalRow: any[] = ['Total'];
  
  maleCategoryIds.forEach((id) => {
    const total = batchCategory.content.reduce((sum, batch) => {
      const category = batch.categories.find((cat) => cat.id === id);
      return sum + (category?.quantity || 0);
    }, 0);
    totalRow.push(total);
  });
  
  femaleCategoryIds.forEach((id) => {
    const total = batchCategory.content.reduce((sum, batch) => {
      const category = batch.categories.find((cat) => cat.id === id);
      return sum + (category?.quantity || 0);
    }, 0);
    totalRow.push(total);
  });
  
  const grandTotal = batchCategory.content.reduce((sum, batch) => {
    return sum + batch.categories.reduce((batchSum, category) => batchSum + category.quantity, 0);
  }, 0);
  totalRow.push(grandTotal);
  
  rows.push(totalRow);

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  
  worksheet['!cols'] = [
    { wch: 25 }, // Coluna de lotes
    ...Array(12).fill({ wch: 12 }) // 12 colunas de categorias + saldo
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Lotes por Categoria');

  const excelBuffer = XLSX.write(workbook, { 
    bookType: 'xlsx', 
    type: 'array' 
  });

  const blob = new Blob([excelBuffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `lotes-${new Date().toISOString().split('T')[0]}.xlsx`;
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
